import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  LdsButton,
  LdsModal,
  LdsPagination,
  LdsSearch,
  LdsCheckbox,
  LdsLoadingSpinner,
} from "@elilillyco/ux-lds-react";
import {
  SET_ADD_SPECIALITYLIST,
  SET_SELECTED_SPECIALITY,
} from "../../store/details";

import "./../../assets/scss/details/addSpecialtyModal.scss";
import SortableHeader from "../shared/SortableHeader";
const AddSpecialtyModal = ({
  isModalOpen,
  setIsModalOpen,
  specialties,
  onDataUpdate,
  visibleSpecialties,
  setVisibleSpecialties,
}) => {
  const { addspecialtyList, loading, selected } = useSelector(
    ({ details }) => details
  );
  const dispatch = useDispatch();

  let [data, setData] = useState(addspecialtyList);
  var selectedSpecialty = JSON.parse(JSON.stringify(selected));
  const [searchTerm, setSearchTerm] = useState("");
  const [appliedSearchTerm, setAppliedSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPg = Math.ceil(data.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  useEffect(() => {
    let tempData = JSON.parse(JSON.stringify(addspecialtyList));

    //below logic is to remove already present specialties on details screen from Add spec modal
    if (
      visibleSpecialties.specialties &&
      visibleSpecialties.specialties.length > 0
    ) {
      for (let i = 0; i < visibleSpecialties.specialties.length; i++) {
        tempData = tempData.filter(
          (itm) =>
            itm.description !==
            visibleSpecialties.specialties[i].specialty_description
        );
      }
    }
    
    // Apply search filter - only use appliedSearchTerm (triggered by search button/enter)
    if (appliedSearchTerm.trim() !== "") {
      // Support comma-separated search terms
      const searchTerms = appliedSearchTerm.split(',').map(term => term.trim().toLowerCase()).filter(term => term !== '');
      
      if (searchTerms.length > 0) {
        tempData = tempData.filter((obj) => {
          const specialty = obj.specialty.toLowerCase();
          const description = obj.description.toLowerCase();
          
          // Check if any of the search terms match
          return searchTerms.some(term => 
            specialty.includes(term) || description.includes(term)
          );
        });
      }
      setCurrentPage(1);
    }

    // Sort by specialty code with natural/numeric sorting for better readability
    tempData.sort((a, b) => {
      // If no search is applied, show selected items at the top
      if (appliedSearchTerm.trim() === "") {
        if (a.isChecked && !b.isChecked) return -1;
        if (!a.isChecked && b.isChecked) return 1;
      }
      
      // Use localeCompare with numeric option for natural sorting (1, 10, 100 instead of 1, 100, 10)
      return a.specialty.localeCompare(b.specialty, undefined, { numeric: true, sensitivity: 'base' });
    });

    setData(tempData);
  }, [addspecialtyList, appliedSearchTerm, visibleSpecialties]);

  //below function is triggerd when Add button is clicked
  function handleAddForm() {
    let tempData = JSON.parse(JSON.stringify(addspecialtyList));
    tempData.forEach((obj) => (obj.isChecked = false));
    dispatch(SET_ADD_SPECIALITYLIST(tempData));

    let finalSelectedList = [];
    //below logic is to remove specialties which we have been checked and added so they are not shown in Add specialty modal now.
    if (selectedSpecialty && selectedSpecialty.length > 0) {
      for (let i = 0; i < selectedSpecialty.length; i++) {
        tempData = tempData.filter((itm) => itm.uuid !== selectedSpecialty[i]);
      }
      setData(tempData);
    }
    addspecialtyList.forEach((slData) => {
      if (selected.includes(slData.uuid)) {
        finalSelectedList.push({
          uuid: slData.uuid,
          specialty_code: slData.specialty,
          specialty_description: slData.description,
          responsibility_code: "",
          incentivized: false,
          show: true,
          selectedSpecialty: false,
        });
      }
    });
    let tempSpecialtyList = JSON.parse(JSON.stringify(visibleSpecialties));
    for (let i = 0; i < finalSelectedList.length; i++) {
      tempSpecialtyList.specialties.push(finalSelectedList[i]);
    }

    dispatch(SET_SELECTED_SPECIALITY([]));
    setVisibleSpecialties(tempSpecialtyList);
    // dispatch(FETCH_ADD_SPECIALTIES_LIST());
    onDataUpdate(finalSelectedList);
    setSearchTerm("");
    setAppliedSearchTerm("");
    setIsModalOpen(false);
  }
  //below function is triggerd when close button is clicked
  function closeModal() {
    setSearchTerm("");
    setAppliedSearchTerm("");
    setIsModalOpen(false);
  }
  //below function is triggered when page no. is clicked
  function clickLink(e, value) {
    setCurrentPage(value);
  }
  //below function is triggerd when Next button is clicked in pagination component
  function clickNext() {
    setCurrentPage((prev) => {
      return prev + 1;
    });
  }
  //below function is triggerd when Prev button is clicked in pagination component
  function clickPrev() {
    setCurrentPage((prev) => {
      return prev - 1;
    });
  }
  //below function is triggerd when we submit the value entered in searchbar
  function submitSearch() {
    // Update the applied search term which triggers the useEffect to filter
    setAppliedSearchTerm(searchTerm);
    setCurrentPage(1);
  }
  // below function is triggered when checkbox is clicked
  function checkBoxClicked(event, UUID) {
    let tempData = JSON.parse(JSON.stringify(addspecialtyList));
    let updatedSelected = [...selectedSpecialty];

    for (let i = 0; i < tempData.length; i++) {
      if (UUID === tempData[i].uuid) {
        if (event.target.checked === true) {
          tempData[i].isChecked = true;
          if (!updatedSelected.includes(UUID)) {
            updatedSelected.push(UUID);
          }
        } else {
          tempData[i].isChecked = false;
          updatedSelected = updatedSelected.filter((itm) => itm !== UUID);
        }
      }
    }

    dispatch(SET_ADD_SPECIALITYLIST(tempData));
    dispatch(SET_SELECTED_SPECIALITY(updatedSelected));
  }
  
  // Select all specialties in the current filtered data
  function selectAllSpecialties() {
    let tempData = JSON.parse(JSON.stringify(addspecialtyList));
    let updatedSelected = [...selectedSpecialty];
    
    // Get all UUIDs from the filtered data
    const filteredUUIDs = data.map(item => item.uuid);
    
    for (let i = 0; i < tempData.length; i++) {
      if (filteredUUIDs.includes(tempData[i].uuid)) {
        tempData[i].isChecked = true;
        if (!updatedSelected.includes(tempData[i].uuid)) {
          updatedSelected.push(tempData[i].uuid);
        }
      }
    }

    dispatch(SET_ADD_SPECIALITYLIST(tempData));
    dispatch(SET_SELECTED_SPECIALITY(updatedSelected));
  }
  
  // Unselect all specialties in the current filtered data
  function unselectAllSpecialties() {
    let tempData = JSON.parse(JSON.stringify(addspecialtyList));
    let updatedSelected = [...selectedSpecialty];
    
    // Get all UUIDs from the filtered data
    const filteredUUIDs = data.map(item => item.uuid);
    
    for (let i = 0; i < tempData.length; i++) {
      if (filteredUUIDs.includes(tempData[i].uuid)) {
        tempData[i].isChecked = false;
        updatedSelected = updatedSelected.filter(uuid => uuid !== tempData[i].uuid);
      }
    }

    dispatch(SET_ADD_SPECIALITYLIST(tempData));
    dispatch(SET_SELECTED_SPECIALITY(updatedSelected));
  }
  
  // Toggle between select all and unselect all
  function toggleSelectAll() {
    // Check if all items in current filtered data are selected
    const filteredUUIDs = data.map(item => item.uuid);
    const allSelected = filteredUUIDs.every(uuid => selected.includes(uuid));
    
    if (allSelected) {
      unselectAllSpecialties();
    } else {
      selectAllSpecialties();
    }
  }
  
  // Determine button text based on selection state
  function getSelectButtonText() {
    const filteredUUIDs = data.map(item => item.uuid);
    const allSelected = filteredUUIDs.every(uuid => selected.includes(uuid));
    return allSelected ? "Unselect All" : "Select All";
  }
  
  const tableHead = ["Specialty Code", "Description"];

  return (
    <>
      <LdsModal
        modalId="add-spclty-modal"
        open={isModalOpen}
        setModalOpen={setIsModalOpen}
        heading="Add Specialty"
      >
        <div>
          <div className="row search-row">
            <div className="col-12 col-md-6">
              <strong>Search Specialty </strong>
              <LdsSearch
                id={"searchSpecialty"}
                onChange={setSearchTerm}
                value={searchTerm}
                onSubmit={submitSearch}
              />
            </div>
            <div className="col-6 button-col">
              {data.length > 0 && (
                <LdsButton
                  iconPosition="before"
                  classes="button-icon-left blue-bdr-btn"
                  onClick={toggleSelectAll}
                >
                  {getSelectButtonText()}
                </LdsButton>
              )}
            </div>
          </div>
          {loading ? (
            <LdsLoadingSpinner size={90} />
          ) : (
            <div>
              {data.length > 0 ? (
                <>
                  <table id="specialities-table" className="lds-table flat">
                    <thead>
                      <tr>
                        <SortableHeader
                          headAlign={"align-left b"}
                          header={tableHead}
                          rowData={data}
                          rowKeyName={["specialty", "description"]}
                          sortedRowData={setData}
                        />
                      </tr>
                    </thead>
                    <tbody>
                      {data.map(
                        (itm, index) =>
                          index >= indexOfFirstItem &&
                          index < indexOfLastItem && (
                            <tr key={itm.uuid}>
                              <td>
                                <LdsCheckbox
                                  required={false}
                                  value={itm.uuid}
                                  name={"specialty-checkbox-" + itm.uuid}
                                  id={"specialty-checkbox-" + itm.uuid}
                                  onChange={(event) =>
                                    checkBoxClicked(event, itm.uuid)
                                  }
                                  checked={itm.isChecked}
                                ></LdsCheckbox>
                                {itm.specialty}
                              </td>
                              <td>{itm.description}</td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </table>
                  <div className="row">
                    <div className="col">
                      <LdsPagination
                        className="floatRight"
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        onLinkClick={clickLink}
                        totalPages={totalPg}
                        onNextClick={clickNext}
                        onPrevClick={clickPrev}
                      />
                    </div>
                  </div>

                  <div className="floatRight">
                    <LdsButton
                      iconPosition="before"
                      classes="button-icon-left blue-bdr-btn"
                      onClick={closeModal}
                    >
                      Cancel
                    </LdsButton>
                    <span className="buttonMargin">
                      <LdsButton
                        iconPosition="before"
                        classes="button-icon-left blue-btn"
                        className="buttonMargin"
                        onClick={handleAddForm}
                      >
                        Add
                      </LdsButton>
                    </span>
                  </div>
                </>
              ) : (
                <p className="no-record-message">No Record Found</p>
              )}
            </div>
          )}
        </div>
      </LdsModal>
    </>
  );
};
export default AddSpecialtyModal;
